import { useCallback } from "react";

const updateItemClassification = (sourceInvoice, line, value, attribute, position) => ({
	items: sourceInvoice.items.map((item) =>
		item.line === line
			? {
				...item,
				accounting_specifications: {
					...item.accounting_specifications,
					[position]: {
						...item.accounting_specifications[position],
						[attribute]: value,
					},
				},
			}
			: item
	),
});

export const useInvoiceFields = ({ currentInvoice, onUpdateItem, company, position }) => {
	const editItemDescription = (value, line) => {
		const updatedData = updateItemClassification(currentInvoice, line, value, "final_description", position);
		onUpdateItem(updatedData);
	};

	const selectItemClassification = (value, line) => {
		const account = company.accounting_resources.accounting_plan.find(
			(plan) => `${plan.id}` === `${value}`
		);

		if (!account) return;

		const updatedData = updateItemClassification(
			currentInvoice,
			line,
			account.id,
			"accounting_classification",
			position,
		);
		onUpdateItem(updatedData);
	};

	const selectItemAnalyticClassification = (value, line) => {
		const analyticAccount = company.accounting_resources.others.analytic_accounts.find(
			(account) => `${account.id}` === `${value}`
		);

		if (!analyticAccount) return;

		const updatedData = updateItemClassification(
			currentInvoice,
			line,
			analyticAccount.id,
			"analytic_classification",
			position,
		);
		onUpdateItem(updatedData);
	};

	const updateGeneralFields = useCallback(
		(property, value) => {
			const updatedData = {
				accounting_specifications: {
					...currentInvoice.accounting_specifications,
					[position]: {
						...currentInvoice.accounting_specifications[position],
						[property]: value,
					},
				},
			};
			onUpdateItem(updatedData);
		},
		[currentInvoice, onUpdateItem]
	);

	const getDiaryInformation = () => {
		const result = company.accounting_resources.diaries.length > 0
			? company.accounting_resources.diaries.filter(
				(element) =>
					`${element.id}` === `${currentInvoice.accounting_specifications[position].diary}`											
			)
			: "";

		if(result.length === 0) return "";

		return result[0].name;
	};

	return {
		editItemDescription,
		selectItemClassification,
		selectItemAnalyticClassification,
		updateGeneralFields,
		getDiaryInformation,
	};
};
